// California counties available for eFiling (46 counties)
// This data will eventually come from the EFM API
export const CA_COUNTIES = [
    { code: 'alameda', name: 'Alameda', state: 'CA' },
    { code: 'alpine', name: 'Alpine', state: 'CA' },
    { code: 'amador', name: 'Amador', state: 'CA' },
    { code: 'butte', name: 'Butte', state: 'CA' },
    { code: 'calaveras', name: 'Calaveras', state: 'CA' },
    { code: 'colusa', name: 'Colusa', state: 'CA' },
    { code: 'contra-costa', name: 'Contra Costa', state: 'CA' },
    { code: 'del-norte', name: 'Del Norte', state: 'CA' },
    { code: 'el-dorado', name: 'El Dorado', state: 'CA' },
    { code: 'fresno', name: 'Fresno', state: 'CA' },
    { code: 'glenn', name: 'Glenn', state: 'CA' },
    { code: 'humboldt', name: 'Humboldt', state: 'CA' },
    { code: 'imperial', name: 'Imperial', state: 'CA' },
    { code: 'inyo', name: 'Inyo', state: 'CA' },
    { code: 'kern', name: 'Kern', state: 'CA' },
    { code: 'kings', name: 'Kings', state: 'CA' },
    { code: 'lake', name: 'Lake', state: 'CA' },
    { code: 'lassen', name: 'Lassen', state: 'CA' },
    { code: 'los-angeles', name: 'Los Angeles', state: 'CA' },
    { code: 'madera', name: 'Madera', state: 'CA' },
    { code: 'marin', name: 'Marin', state: 'CA' },
    { code: 'mariposa', name: 'Mariposa', state: 'CA' },
    { code: 'mendocino', name: 'Mendocino', state: 'CA' },
    { code: 'merced', name: 'Merced', state: 'CA' },
    { code: 'mono', name: 'Mono', state: 'CA' },
    { code: 'monterey', name: 'Monterey', state: 'CA' },
    { code: 'napa', name: 'Napa', state: 'CA' },
    { code: 'nevada', name: 'Nevada', state: 'CA' },
    { code: 'orange', name: 'Orange', state: 'CA' },
    { code: 'placer', name: 'Placer', state: 'CA' },
    { code: 'riverside', name: 'Riverside', state: 'CA' },
    { code: 'sacramento', name: 'Sacramento', state: 'CA' },
    { code: 'san-benito', name: 'San Benito', state: 'CA' },
    { code: 'san-bernardino', name: 'San Bernardino', state: 'CA' },
    { code: 'san-diego', name: 'San Diego', state: 'CA' },
    { code: 'san-francisco', name: 'San Francisco', state: 'CA' },
    { code: 'san-joaquin', name: 'San Joaquin', state: 'CA' },
    { code: 'san-luis-obispo', name: 'San Luis Obispo', state: 'CA' },
    { code: 'san-mateo', name: 'San Mateo', state: 'CA' },
    { code: 'santa-barbara', name: 'Santa Barbara', state: 'CA' },
    { code: 'santa-clara', name: 'Santa Clara', state: 'CA' },
    { code: 'santa-cruz', name: 'Santa Cruz', state: 'CA' },
    { code: 'shasta', name: 'Shasta', state: 'CA' },
    { code: 'solano', name: 'Solano', state: 'CA' },
    { code: 'sonoma', name: 'Sonoma', state: 'CA' },
    { code: 'stanislaus', name: 'Stanislaus', state: 'CA' },
    { code: 'sutter', name: 'Sutter', state: 'CA' },
    { code: 'tulare', name: 'Tulare', state: 'CA' },
    { code: 'ventura', name: 'Ventura', state: 'CA' },
    { code: 'yolo', name: 'Yolo', state: 'CA' },
    { code: 'yuba', name: 'Yuba', state: 'CA' },
];
export const getCountiesByState = (stateCode) => {
    if (stateCode === 'CA')
        return CA_COUNTIES;
    return [];
};
